import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8a1cd0e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "data-cy": "domain-target-table-domain-name",
  class: "tw-text-[#211F58] tw-text-[13px] tw-font-[600] tw-leading-[130%]"
}
const _hoisted_2 = {
  key: 0,
  class: "custom-global-skeleton tw-w-[120px] tw-h-[15px]"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "tw-text-[13px] tw-text-[#387dff] tw-not-italic tw-font-normal"
}
const _hoisted_5 = {
  key: 1,
  class: "tw-text-[13px] tw-text-[#878787] tw-not-italic tw-font-normal"
}
const _hoisted_6 = {
  key: 2,
  class: "tw-text-[13px] tw-text-[#878787] tw-not-italic tw-font-normal"
}
const _hoisted_7 = {
  key: 3,
  class: "tw-ml-2"
}
const _hoisted_8 = { class: "tw-w-full tw-flex tw-h-[67px] tw-items-center" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "custom-global-skeleton tw-w-[120px] tw-h-[15px]"
}
const _hoisted_11 = { key: 2 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-h-full tw-w-[28px] tw-cursor-default" }, null, -1))
const _hoisted_13 = { class: "tw-w-full tw-h-full tw-flex tw-items-center" }
const _hoisted_14 = { class: "tw-min-w-[100px]" }
const _hoisted_15 = {
  key: 0,
  class: "custom-global-skeleton tw-w-[120px] tw-h-[15px]"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 0,
  class: "custom-global-skeleton tw-w-[120px] tw-h-[15px]"
}
const _hoisted_19 = {
  key: 1,
  class: "tw-text-[#211F58] tw-text-[13px] tw-font-normal tw-ml-[35px]"
}
const _hoisted_20 = {
  key: 0,
  class: "custom-global-skeleton tw-w-[120px] tw-h-[15px]"
}
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { class: "tw-text-[13px] tw-text-[#01893D] tw-not-italic tw-font-normal" }
const _hoisted_23 = { key: 3 }
const _hoisted_24 = { class: "tw-text-[13px] tw-text-[#F7553C] tw-not-italic tw-font-normal" }
const _hoisted_25 = { class: "tw-flex tw-items-center tw-justify-end tw-h-full" }
const _hoisted_26 = { class: "tw-pr-[25px]" }
const _hoisted_27 = {
  key: 0,
  class: "custom-global-skeleton tw-w-[120px] tw-h-[15px]"
}
const _hoisted_28 = ["id", "onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["disabled"]

import { computed, onMounted, ref, watch } from "vue";
import CustomTable from "@/components/common/customTable.vue";
import ArrowDownTableIcon from "../svgs/arrowDownTableIcon.vue";
import ButtonDropdown from "../common/buttonDropdown.vue";
import ProgressIndicator from "./progressIndicator.vue";
import IssuesNumberDots from "./issuesNumberDots.vue";
import WebServicesDetailTab from "./webServicesDetailTab.vue";
import {
  MODAL_NAME,
  actionClickType,
  TYPE_SCHEDULE,
  statusScanProgress,
  TYPE_ERROR_LIMIT_START_SCAN,
  successStatusCodes,
} from "@/utils/constants";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import {
  downloadCSV,
  getComponentUiText,
  getLatestScan,
} from "@/utils/utilities";
import {
  getScanReportDomainCSV,
  postScanReportRunDomain,
} from "@/services/scanning";
import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import { Scanning } from "@/services/apiRoutes/routes";
import store from "@/store";
import { SCANNING_STATUS_TARGETS } from "@/utils/constants";
import ScheduleModal from "./scheduleModal.vue";
import CustomDropDownItem from "../common/customDropDownItem.vue";
import CalenderClockIcon from "../svgs/calenderClockIcon.vue";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";


export default /*#__PURE__*/_defineComponent({
  __name: 'domainsTargetTable',
  props: {
  isDraggable: {
    type: Boolean,
    required: false,
  },
  loading: {
    type: Boolean,
    required: false,
  },
},
  emits: ["update-selected-rows"],
  setup(__props, { emit }) {

const props = __props;





const show = ref(false);
const idItemExtend = ref(null);
const idItemStartScanExtend = ref(null);
const targetId = ref(null);
const listDomains = computed(() => {
  const data = store.state.Scanning.listScansHistoryDomains.map((item) => {
    item.scanReportRuns.sort(
      (a, b) =>
        new Date(a.startedAt || 0).getTime() -
        new Date(b.startedAt || 0).getTime(),
    );
    return {
      ...item,
      id: item.id || item.domainId,
      ...getLatestScan(item),
    };
  });
  return data.sort((a, b) => b.latestScanTime - a.latestScanTime);
});

watch(
  () => props.loading,
  (value) => {
    isLoading.value = value;
  },
);

const scheduleData = (targetId) => {
  return store.getters["Scanning/GET_SCHEDULED_ITEM"]({
    type: TYPE_SCHEDULE.domains,
    id: targetId,
  });
};

const isRefreshing = computed(() => store.state.Scanning.isLoading);
const domainScanningId = computed(() => store.state.Scanning.domainScanningId);
const isLoadingDomainTable = computed(
  () => store.getters["Scanning/GET_IS_LOADING_DOMAINS"],
);

const isLoading = ref(isLoadingDomainTable.value);
const detailHoveringId = ref(null);

const getScanRunStatusId = (item) => {
  return item.scanReportRuns?.[item.latestScanIndex]?.runStatusId;
};

const onClickOpenRow = (item, col) => {
  if (!col.isActiveClick || !item.scanReportRuns?.length) return;
  handleExpandItem(item.id);
};

const getIssuesLatestScan = (item) => {
  const data = item.scanReportRuns[item.latestScanIndex];
  if (!data) return undefined;
  return {
    critical: data.critical,
    high: data.high,
    medium: data.med,
    low: data.low,
  };
};

onMounted(async () => {
  await store.dispatch("Scanning/fetchScanHistoryDomains");
  await store.dispatch("Scanning/fetchScanIssuesHistoryDomains");

  isLoading.value = false;

  EventEmitter.on(EmitterEvents.OPEN_SCAN_POPOVER, (dataType) => {
    if (!dataType || dataType !== "domain") {
      idItemStartScanExtend.value = null;
    }
  });
});

const startScan = async (data) => {
  EventEmitter.emit(EmitterEvents.OPEN_SCAN_POPOVER);
  if (getScanRunStatusId(data) === statusScanProgress.SCAN_IN_PROGRESS) return;
  store.commit("Scanning/SET_DATA_REFRESH_LOADING", {
    isLoading: true,
    webserviceIds: null,
    domainIds: data.domainId,
  });
  try {
    const result = await postScanReportRunDomain(data.id);
    setTimeout(async () => {
      await store.dispatch("Scanning/refreshIssuesDomainScanning", {
        domainIds: data.domainId,
      });
    }, 1000);

    if (result.status === successStatusCodes.OK) {
      const service = listDomains.value.find(
        (item) => item.domainId === data.domainId,
      );

      if (service) {
        if (service.scanReportRuns.length === 0) {
          service.scanReportRuns.push({
            runStatusId: statusScanProgress.SCAN_IN_PROGRESS,
          });
        } else {
          const scanRun = service.scanReportRuns[0];
          scanRun.runStatusId = statusScanProgress.SCAN_IN_PROGRESS;
        }
      }
    }
  } catch (error) {
    if (
      error?.data?.error?.errors.find(
        (item) => item.type === TYPE_ERROR_LIMIT_START_SCAN.ERROR,
      )?.type === TYPE_ERROR_LIMIT_START_SCAN.ERROR
    ) {
      const emitData = {
        component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
        properties: {
          value: {},
          title: getComponentUiText(
            "app-scanning-schedule-modal-title-maximum-scan-limit-reached-1",
          ),
          description: getComponentUiText(
            "app-scanning-schedule-modal-description-maximum-scan-limit-reached-1",
          ),
          buttonText: getComponentUiText(
            "app-scanning-schedule-modal-button-got-it-1",
          ),
          buttonRed: false,
          slotCustom: null,
          hiddenHelp: false,
          isShowBtnCancel: false,
        },
        events: {},
      };
      EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
    } else {
      showErrorAPI(error, Scanning.postScanReportRunDomain);
    }
  } finally {
    setTimeout(() => {
      store.commit("Scanning/SET_DATA_REFRESH_LOADING", {
        isLoading: false,
        webserviceIds: null,
        domainIds: null,
      });
    }, 1500);
  }
};

const exportCSV = async (data) => {
  try {
    const latestRunId =
      data.scanReportRuns?.[data.latestScanIndex]?.scanReportRunId;
    const res = await getScanReportDomainCSV(latestRunId);
    downloadCSV(res, "DomainScanning.csv");
  } catch (error) {
    showErrorAPI(error, Scanning.getScanReportDomainCSV);
  } finally {
    showSuccessToast(
      getComponentUiText("app-api-scanning-export-csv-success-1"),
    );
  }
};

const handleExpandItem = (id) => {
  EventEmitter.emit(EmitterEvents.OPEN_SCAN_POPOVER);
  idItemExtend.value = idItemExtend.value === id ? null : id;
};

const tableFileActions = [actionClickType.actionEditActionRecomendation];

const handleActionClick = (value, action) => {
  switch (action) {
    case actionClickType.actionEditActionRecomendation:
      onShowEditActionModal();
      break;
    default:
      break;
  }
};

const onShowEditActionModal = () => {
  const emitData = {
    component: MODAL_NAME.MODAL_RECOMMENDATION_EDIT_ACTIONS,
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const editSchedule = (id) => {
  targetId.value = id;
  show.value = true;
  idItemStartScanExtend.value = null;
};

const refresh = async (data) => {
  store.commit("Scanning/SET_DATA_REFRESH_LOADING", {
    isLoading: true,
    webserviceIds: null,
    domainIds: data.domainId,
  });
  try {
    await store.dispatch("Scanning/refreshIssuesDomainScanning", {
      domainIds: data.domainId,
    });
  } catch (error) {
    console.log(error);
  } finally {
    store.commit("Scanning/SET_DATA_REFRESH_LOADING", {
      isLoading: false,
      webserviceIds: null,
      domainIds: null,
    });
  }
};

const handleSelect = (seletedRow) => {
  emit("update-selected-rows", seletedRow);
};

const columnsTableFields = [
  {
    text: getComponentUiText("app-scan-scanning-targets-header-table-target-1"),
    value: "target",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase !tw-min-w-[200px] tw-h-[46px]",
    valueClass: "!tw-w-[111px] tw-h-[68px] !tw-p-0",
    sortable: false,
    isActiveClick: true,
  },
  {
    text: getComponentUiText(
      "app-scan-scanning-targets-header-table-last-scanned-1",
    ),
    value: "lastScanned",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase !tw-pr-0 !tw-min-w-[170px] tw-h-[46px]",
    valueClass: "!tw-w-[111px] tw-h-[68px] !tw-p-0",
    sortable: false,
    isActiveClick: true,
  },
  {
    text: getComponentUiText("app-scan-scanning-targets-header-table-issues-1"),
    value: "issues",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase !tw-pr-0 !tw-min-w-[170px] tw-h-[46px]",
    valueClass: "!tw-w-[11px] !tw-p-0",
    sortable: false,
  },
  {
    text: getComponentUiText(
      "app-scan-scanning-targets-header-table-scan-report-1",
    ),
    value: "scanReport",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase !tw-min-w-[170px] tw-h-[46px]",
    valueClass: "!tw-w-[111px] tw-h-[68px] !tw-p-0",
    sortable: false,
  },
  {
    text: getComponentUiText(
      "app-scan-scanning-targets-header-table-total-scans-1",
    ),
    value: "totalScans",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase !tw-pr-0 !tw-min-w-[170px] tw-h-[46px]",
    valueClass: "!tw-w-[111px] tw-h-[68px] !tw-p-0",
    sortable: false,
    isActiveClick: true,
  },
  {
    text: getComponentUiText(
      "app-scan-scanning-targets-header-table-scan-progress-1",
    ),
    value: "scanProgress",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase !tw-pr-0 !tw-min-w-[120px] tw-h-[46px]",
    valueClass: "!tw-w-[111px] tw-h-[68px] !tw-p-0",
    sortable: false,
    isActiveClick: true,
  },
  {
    text: "",
    value: "action",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase !tw-min-w-[100px] tw-h-[46px] tw-justify-end tw-pr-[145px]",
    valueClass: "!tw-w-[21px] !tw-px-0 !tw-py-0 tw-h-[68px] !tw-p-0",
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CustomTable, {
    draggable: __props.isDraggable,
    columns: columnsTableFields,
    "empty-text": 
      _unref(getComponentUiText)('app-scan-scanning-domains-table-empty-text-1')
    ,
    data: listDomains.value,
    "is-loading": isLoadingDomainTable.value || isLoading.value,
    "skeleton-row-number": 1,
    "id-item-expland": idItemExtend.value,
    "color-checkmark": '#01893D',
    "header-wrapper-class": "!tw-bg-[#FCFCFD]",
    "custom-class": `scannings-targets-table ${
      idItemExtend.value ? 'table-sticky-header' : ''
    }`,
    "hover-bg-color": '!tw-bg-[#F2F8FF]',
    "extend-active-bg-color": '!tw-bg-[#F2F8FF]',
    "detail-hovering-id": detailHoveringId.value,
    "data-type": "domain",
    onUpdateSelectedRows: _cache[3] || (_cache[3] = ($event: any) => (handleSelect($event))),
    onClickedRow: onClickOpenRow
  }, {
    "cell(target)": _withCtx((data) => [
      _createElementVNode("div", {
        class: _normalizeClass(`${
          data.item.scanReportRuns?.length ? 'tw-cursor-pointer' : ''
        } tw-w-full tw-h-full tw-flex tw-items-center`)
      }, [
        _createElementVNode("span", _hoisted_1, _toDisplayString(data.item.domainName), 1)
      ], 2)
    ]),
    "cell(lastScanned)": _withCtx((data) => [
      _createElementVNode("div", {
        class: _normalizeClass(`${
          data.item.scanReportRuns?.length ? 'tw-cursor-pointer' : ''
        } tw-w-full tw-h-full tw-flex tw-items-center`)
      }, [
        (isRefreshing.value && data.item.domainId === domainScanningId.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (
              getScanRunStatusId(data.item) ===
              _unref(statusScanProgress).SCAN_IN_PROGRESS
            )
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(getComponentUiText)("app-scan-scanning-in-progress-1")), 1))
                : (data.item.latestScanTime)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(convertUTCTimeToLocalTime)(
                data?.item?.latestScanTime,
                undefined,
                "HH:mm",
              )), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(getComponentUiText)(
                "app-scanning-schedule-targets-table-value-last-scanned-never-1",
              )), 1)),
              (Boolean(scheduleData(data.item.id)))
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    _createVNode(CalenderClockIcon, {
                      size: 14,
                      color: 878787
                    })
                  ]))
                : _createCommentVNode("", true)
            ]))
      ], 2)
    ]),
    "cell(issues)": _withCtx((data) => [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: _normalizeClass(`tw-flex-1 tw-h-full tw-items-center tw-flex ${
            data.item.scanReportRuns?.length ? 'tw-cursor-pointer' : ''
          }`),
          onClick: () => onClickOpenRow(data.item, columnsTableFields[0])
        }, [
          (isRefreshing.value && data.item.domainId === domainScanningId.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10))
            : (
              data.item.scanReportRuns?.length &&
              getScanRunStatusId(data.item) === _unref(statusScanProgress).SCAN_COMPLETE
            )
              ? (_openBlock(), _createBlock(IssuesNumberDots, {
                  key: 1,
                  "scan-target-type": _unref(TYPE_SCHEDULE).domains,
                  "current-refresh-id": data.item.domainId,
                  severity: getIssuesLatestScan(data.item)
                }, null, 8, ["scan-target-type", "current-refresh-id", "severity"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11))
        ], 10, _hoisted_9),
        _hoisted_12
      ])
    ]),
    "cell(scanReport)": _withCtx((data) => [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          (isRefreshing.value && data.item.domainId === domainScanningId.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15))
            : (
              getScanRunStatusId(data.item) === _unref(SCANNING_STATUS_TARGETS).COMPLETE
            )
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: "tw-text-[13px] tw-text-[#387DFF] tw-not-italic tw-font-normal tw-leading-[145%] tw-cursor-pointer",
                  onClick: ($event: any) => (exportCSV(data.item))
                }, _toDisplayString(_unref(getComponentUiText)(
                "app-scan-scanning-targets-btn-table-scan-report-1",
              )), 9, _hoisted_16))
              : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(`tw-flex-1 tw-h-full ${
            data.item.scanReportRuns?.length ? 'tw-cursor-pointer' : ''
          }`),
          onClick: () => onClickOpenRow(data.item, columnsTableFields[0])
        }, null, 10, _hoisted_17)
      ])
    ]),
    "cell(totalScans)": _withCtx((data) => [
      _createElementVNode("div", {
        class: _normalizeClass(`${
          data.item.scanReportRuns?.length ? 'tw-cursor-pointer' : ''
        } tw-w-full tw-h-full tw-flex tw-items-center`)
      }, [
        (isRefreshing.value && data.item.domainId === domainScanningId.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18))
          : (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(data.item.scanReportRuns.length), 1))
      ], 2)
    ]),
    "cell(scanProgress)": _withCtx((data) => [
      _createElementVNode("div", {
        class: _normalizeClass(`${
          data.item.scanReportRuns?.length ? 'tw-cursor-pointer' : ''
        } tw-w-full tw-h-full tw-flex tw-items-center`)
      }, [
        (isRefreshing.value && data.item.domainId === domainScanningId.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20))
          : (
            getScanRunStatusId(data.item) ===
            _unref(statusScanProgress).SCAN_IN_PROGRESS
          )
            ? (_openBlock(), _createBlock(ProgressIndicator, {
                key: 1,
                progress: 40
              }))
            : (
            getScanRunStatusId(data.item) === _unref(statusScanProgress).SCAN_COMPLETE
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(getComponentUiText)(
                "app-scan-scanning-targets-header-table-scan-progress-status-complete-1",
              )), 1)
                ]))
              : (
            getScanRunStatusId(data.item) === _unref(statusScanProgress).SCAN_ERR
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(getComponentUiText)(
                "app-scan-scanning-targets-header-table-scan-progress-status-error-1",
              )), 1)
                  ]))
                : _createCommentVNode("", true)
      ], 2)
    ]),
    "cell(action)": _withCtx((data) => [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          (isRefreshing.value && data.item.domainId === domainScanningId.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27))
            : (
              getScanRunStatusId(data.item) ===
              _unref(statusScanProgress).SCAN_IN_PROGRESS
            )
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  id: 'btn-refresh-scan-domain-' + data.idx,
                  class: "tw-min-w-[133px] tw-text-[#01893D] tw-bg-[#FFF] tw-border-[#D9EDE2] tw-border-[2px] tw-border-solid tw-cursor-pointer hover:tw-bg-[#01893D] hover:tw-text-white tw-py-[8px] tw-px-[18px] tw-text-[13px] tw-font-medium tw-rounded-[100px]",
                  onClick: ($event: any) => (refresh(data.item))
                }, _toDisplayString(_unref(getComponentUiText)("app-scan-scanning-refresh-number-block-1")), 9, _hoisted_28))
              : (_openBlock(), _createBlock(ButtonDropdown, {
                  key: 2,
                  "id-btn": 'btn-start-scan-domain-' + data.idx,
                  "id-popover": 'popover-domain-target-table-' + data.idx,
                  "custom-class": 'tw-w-[max-content]  md:tw-max-w-[350px] lg:tw-max-w-[470px]',
                  classes: `!tw-leading-none `,
                  "button-class": `tw-min-w-[133px] tw-border-none ${
              getScanRunStatusId(data.item) ===
              _unref(statusScanProgress).SCAN_IN_PROGRESS
                ? 'tw-bg-[#EFF0F1] tw-cursor-not-allowed'
                : 'tw-bg-[#D9EDE2] tw-cursor-pointer hover:tw-opacity-70'
            }`,
                  "color-text": `${
              getScanRunStatusId(data.item) ===
              _unref(statusScanProgress).SCAN_IN_PROGRESS
                ? '#B7B7B7'
                : '#01893D'
            }`,
                  disabled: 
              getScanRunStatusId(data.item) ===
              _unref(statusScanProgress).SCAN_IN_PROGRESS
            ,
                  title: 
              _unref(getComponentUiText)('app-scan-scanning-targets-btn-start-scan-1')
            ,
                  "arrow-class": 
              data.item.id === idItemStartScanExtend.value ? 'tw-rotate-180' : ''
            ,
                  "active-dropdown": data.item.id === idItemStartScanExtend.value,
                  "data-type": 'domain',
                  onClickTitle: ($event: any) => (startScan(data.item)),
                  onClickDropdown: ($event: any) => (
              idItemStartScanExtend.value =
                idItemStartScanExtend.value === data.item.id ? null : data.item.id
            ),
                  onLeave: _cache[0] || (_cache[0] = ($event: any) => (idItemStartScanExtend.value = null))
                }, {
                  default: _withCtx(() => [
                    _createVNode(CustomDropDownItem, {
                      style: 'basic',
                      "id-text": 'app-scanning-schedule-modal-button-1',
                      padding: 'tw-p-[15px] ',
                      "custom-class": 'tw-rounded-[6px] tw-flex',
                      onClick: ($event: any) => (editSchedule(data.item.id))
                    }, null, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1032, ["id-btn", "id-popover", "button-class", "color-text", "disabled", "title", "arrow-class", "active-dropdown", "onClickTitle", "onClickDropdown"]))
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(`tw-flex tw-items-center tw-h-full ${
            data.item.scanReportRuns?.length ? 'tw-cursor-pointer' : ''
          }`),
          onClick: ($event: any) => (onClickOpenRow(data.item, columnsTableFields[0]))
        }, [
          _createElementVNode("button", {
            class: "tw-border-0 tw-border-solid tw-border-l-[1px] tw-border-[#EFF0F1] tw-px-[25px]",
            disabled: !data.item.scanReportRuns?.length
          }, [
            _createVNode(ArrowDownTableIcon, {
              color: data.item.scanReportRuns?.length ? '#387DFF' : '#fff',
              class: _normalizeClass([
                data.item.id === idItemExtend.value ? 'show' : '',
                data.item.scanReportRuns?.length ? '' : '',
                'tw-p-0',
              ])
            }, null, 8, ["color", "class"])
          ], 8, _hoisted_30)
        ], 10, _hoisted_29)
      ]),
      _createVNode(ScheduleModal, {
        show: show.value,
        title: 
          _unref(getComponentUiText)('app-scanning-schedule-modal-title-content-1')
        ,
        description: 
          _unref(getComponentUiText)('app-scanning-schedule-modal-description-1')
        ,
        "button-text": 
          _unref(getComponentUiText)('app-scanning-schedule-modal-button-1')
        ,
        "is-edit": true,
        "scan-target-type": _unref(TYPE_SCHEDULE).domains,
        "target-id": targetId.value,
        "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => (show.value = $event))
      }, null, 8, ["show", "title", "description", "button-text", "scan-target-type", "target-id"])
    ]),
    detail: _withCtx((data) => [
      _createVNode(WebServicesDetailTab, {
        data: data.item,
        "status-progress": getScanRunStatusId(data.item),
        "is-expand": data.value,
        "scan-target-type": _unref(TYPE_SCHEDULE).domains,
        onHoverIn: () => (detailHoveringId.value = data.item.id),
        onHoverOut: _cache[2] || (_cache[2] = () => (detailHoveringId.value = ''))
      }, null, 8, ["data", "status-progress", "is-expand", "scan-target-type", "onHoverIn"])
    ]),
    _: 1
  }, 8, ["draggable", "empty-text", "data", "is-loading", "id-item-expland", "custom-class", "detail-hovering-id"]))
}
}

})